import { render, staticRenderFns } from "./MliveDetails.vue?vue&type=template&id=48cdbc40&"
import script from "./MliveDetails.vue?vue&type=script&lang=js&"
export * from "./MliveDetails.vue?vue&type=script&lang=js&"
import style0 from "./MliveDetails.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports